import { UseToastOptions } from '@chakra-ui/react';
import { configApi } from '../services/configApi';

export interface IDecodeToken {
  token_type: string;
  exp: number;
  iat: number;
  jti: string;
  user_id: string;
}

export const decodeToken = (): IDecodeToken | undefined => {
  let canUseLocalStorage = false;

  try {
    canUseLocalStorage = !!window.localStorage;
  } catch (e) {
    console.warn('LocalStorage não está acessível: ', e);
  }

  if (canUseLocalStorage) {
    const token = localStorage.getItem('token');
    if (token) {
      const bodyToken = token.split('.')[1];
      return JSON.parse(atob(bodyToken));
    }
  }

  return undefined;
};

export const handleDeleteAttach = async (
  attachmentId: string,
  onToast: (props: UseToastOptions) => void,
  refetch?: () => void,
) => {
  configApi
    .delete(`/attachment/delete/${attachmentId}/`)
    .then(() => {
      onToast({
        title: 'Sucesso',
        description: 'Anexo excluido com sucesso',
        status: 'success',
        duration: 4000,
        isClosable: true,
      });
      if (refetch) {
        refetch();
      }
    })
    .catch(() => {
      onToast({
        title: 'Erro',
        description: 'Erro na solicitação, tente novamente mais tarde',
        status: 'error',
        duration: 4000,
        isClosable: true,
      });
    });
};

export const isValidUUID = (uuid?: string): boolean => {
  if (!uuid) return false;
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  return uuidRegex.test(uuid);
};

export function lighten(hex: string, percent: number) {
  if (!hex) return undefined;
  const num = parseInt(hex.replace('#', ''), 16);
  let r = (num >> 16) + percent;
  let g = ((num >> 8) & 0x00ff) + percent;
  let b = (num & 0x0000ff) + percent;

  r = Math.min(255, Math.max(0, r));
  g = Math.min(255, Math.max(0, g));
  b = Math.min(255, Math.max(0, b));

  return '#' + (b | (g << 8) | (r << 16)).toString(16).padStart(6, '0');
}

export const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 B';

  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const k = 1024;

  const i = Math.floor(Math.log(bytes) / Math.log(k));
  const size = bytes / Math.pow(k, i);

  return `${size.toFixed(2)} ${units[i]}`;
};

export const createFileCopy = async (originalFile: File) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      try {
        const arrayBuffer = event.target?.result;
        if (arrayBuffer) {
          const newBlob = new Blob([arrayBuffer], { type: originalFile.type });
          const newFile = new File([newBlob], originalFile.name, {
            type: originalFile.type,
            lastModified: Date.now(),
          });
          resolve(newFile);
        }
      } catch (error) {
        reject(error);
      }
    };
    reader.onerror = () => reject(new Error('Falha ao ler o arquivo'));
    reader.readAsArrayBuffer(originalFile);
  });
};
